var last_search_letter = null;
var last_search_text = null;
async function searchMembers(term: string, page: number = 1): Promise<void> {
  try {
    // ensure pages get reset if term changes
    if (last_search_letter && last_search_text && term !== last_search_letter && term !== last_search_text) {
      page = 1;
    }

    const response = await fetch(`/employer-members/search?term=${encodeURIComponent(term)}&page=${page}`, {
      method: "GET",
      headers: { "Accept": "application/json" }
    });

    if (!response.ok) {
      throw new Error("Failed to fetch members.");
    }

    const { members, pageCount } = await response.json();
    updateMemberTable(members);
    updatePagination(page, pageCount, term);

    if (page === 1) {
      if (term.length === 1) {
        last_search_letter = term;
      } else {
        last_search_text = term;
      }
    }
  } catch (error) {
    console.error("Error fetching members:", error);
  }
}

function updateMemberTable(members: { FirstName: string; LastName: string; MemberId: string; Relationship: string }[]): void {
  const tableBody = document.getElementById("member-table-body");
  if (!tableBody) return;

  tableBody.innerHTML = ""; // Clear existing rows
  if (members.length < 1) {
    tableBody.innerHTML = '<tr><td class="pt-3">No matches found.</td><td></td><td></td></tr>';
  }

  members.forEach(member => {
    const name = `${member.LastName}, ${member.FirstName}`;
    const row = document.createElement("tr");

    row.innerHTML = `
      <td>
        <input type="submit" class="btn btn-text" data-memberId="${member.MemberId}" value="${name}">
      </td>
      <td class="pt-3">${member.MemberId}</td>
      <td class="pt-3">${member.Relationship}</td>
    `;

    tableBody.appendChild(row);
  });
}

function updatePagination(currentPage: number, pageCount: number, searchTerm: string): void {
  const pagination = document.querySelector(".employer-member-pagination");
  if (!pagination) return;

  pagination.innerHTML = ""; // Clear pagination

  // Previous Button
  if (currentPage > 1) {
    pagination.appendChild(createPageItem("Previous", currentPage - 1, searchTerm));
  }

  const pages = new Set<number>();

  // Always include first pages
  [1, 2, 3].forEach(p => p <= pageCount && pages.add(p));

  // When current page is low, show more at the start
  if (currentPage <= 5) {
    for (let i = 4; i <= Math.min(7, pageCount); i++) {
      pages.add(i);
    }
  } else {
    [currentPage - 2, currentPage - 1, currentPage, currentPage + 1, currentPage + 2]
      .forEach(p => p >= 1 && p <= pageCount && pages.add(p));
  }

  // Always include last pages
  [pageCount - 2, pageCount - 1, pageCount].forEach(p => p > 3 && p <= pageCount && pages.add(p));

  // Convert to sorted array
  const sortedPages = Array.from(pages).sort((a, b) => a - b);

  // Render pagination with ellipsis where gaps exist
  let lastPage = 0;
  sortedPages.forEach((page) => {
    if (lastPage && page - lastPage > 1) {
      pagination.appendChild(createEllipsis());
    }
    pagination.appendChild(createPageItem(page.toString(), page, searchTerm, page === currentPage));
    lastPage = page;
  });

  // Next Button
  if (currentPage < pageCount) {
    pagination.appendChild(createPageItem("Next", currentPage + 1, searchTerm));
  }
}

function createPageItem(text: string, page: number, searchTerm: string, isActive: boolean = false): HTMLLIElement {
  const li = document.createElement("li");
  li.classList.add("page-item");
  if (isActive) {
    li.classList.add("active");
    li.setAttribute("aria-current", "page");
    li.innerHTML = `<span class="page-link">${text} <span class="visually-hidden">(current)</span></span>`;
  } else {
    const anchor = document.createElement("a");
    anchor.classList.add("page-link");
    anchor.href = "#";
    anchor.textContent = text;
    anchor.addEventListener("click", (event) => {
      event.preventDefault();
      searchMembers(searchTerm, page);
    });

    li.appendChild(anchor);
  }

  return li;
}

function createEllipsis(): HTMLLIElement {
  const li = document.createElement("li");
  li.classList.add("page-item");
  li.innerHTML = `<span class="page-link">...</span>`;
  return li;
}

// Text Search
document.getElementById("search-input")?.addEventListener("input", (event) => {
  if (!(event as InputEvent).isTrusted) return; // ignore programtatic clearing from alpha search
  last_search_letter = null;
  const term = (event.target as HTMLInputElement).value;
  searchMembers(term);
});

// Alphabet Search
document.getElementById("search-alpha")?.addEventListener("click", (event) => {
  const target = event.target as HTMLElement;
  if (target.tagName === "A") {
    event.preventDefault();
    last_search_text = null;
    (document.getElementById("search-input") as HTMLInputElement).value = '';
    searchMembers(target.textContent || "");
  }
});

// Pagination Initialization
document.addEventListener("DOMContentLoaded", () => {
  const pagination = document.querySelector(".employer-member-pagination");
  if (pagination) {
    pagination.addEventListener("click", (event) => {
      const target = event.target as HTMLElement;
      const pageAttr = target.dataset.page;
      if (!pageAttr) return; // ignore clicks not on a static page link
      event.preventDefault();

      const currentPage = parseInt((document.querySelector(".page-item.active .page-link") as HTMLElement)?.textContent || "1", 10);
      const page = parseInt(pageAttr, 10) || currentPage;

      const currentSearchTerm = last_search_letter || last_search_text || '';
      searchMembers(currentSearchTerm, Math.max(1, page));
    });
  }
});
